const calculateRatesFormModel = {
  formId: "calculate-rates-form",
  formFields: {
    weight: {
      name: "weight",
      label: "Weight",
      errorMsg: {
        required: "Weight is required.",
        invalid: "Weight is invalid.",
        positive: "Weight must be a positive number.",
        min: "Weight must be greater than 0.",
        max: "Weight must not be more than 150.",
      },
    },
    originatingZip: {
      name: "originatingZip",
      label: "Originating Zip",
      errorMsg: {
        required: "Originating Zip is required.",
        invalid: "Originating Zip is invalid.",
      },
    },
    destinationZip: {
      name: "destinationZip",
      label: "Destination Zip",
      errorMsg: {
        required: "Destination Zip is required.",
        invalid: "Destination Zip is invalid.",
      },
    },
    dropoffPickup: {
      name: "dropoffPickup",
      label: "Dropoff or Pickup",
      errorMsg: {
        required: "You must choose Dropoff or Pickup option",
        invalid: "You must choose Dropoff or Pickup option",
      },
    },
  },
};

export default calculateRatesFormModel;
